
var $ = jQuery.noConflict();
var PTEN = PTEN || {};

(function($) {
    "use strict";
    PTEN.initialize = {
        init: function(){
            PTEN.initialize.responsiveClasses();
        },
        responsiveClasses: function(){

            if( typeof jRespond === 'undefined' ) {
                console.log('responsiveClasses: jRespond not Defined.');
                return true;
            }

            var jRes = jRespond([
                {
                    label: 'smallest',
                    enter: 0,
                    exit: 575
                },{
                    label: 'handheld',
                    enter: 576,
                    exit: 767
                },{
                    label: 'tablet',
                    enter: 768,
                    exit: 991
                },{
                    label: 'laptop',
                    enter: 992,
                    exit: 1199
                },{
                    label: 'desktop',
                    enter: 1200,
                    exit: 10000
                }
            ]);
            jRes.addFunc([
                {
                    breakpoint: 'desktop',
                    enter: function() { $body.addClass('device-xl'); },
                    exit: function() { $body.removeClass('device-xl'); }
                },{
                    breakpoint: 'laptop',
                    enter: function() { $body.addClass('device-lg'); },
                    exit: function() { $body.removeClass('device-lg'); }
                },{
                    breakpoint: 'tablet',
                    enter: function() { $body.addClass('device-md'); },
                    exit: function() { $body.removeClass('device-md'); }
                },{
                    breakpoint: 'handheld',
                    enter: function() { $body.addClass('device-sm'); },
                    exit: function() { $body.removeClass('device-sm'); }
                },{
                    breakpoint: 'smallest',
                    enter: function() { $body.addClass('device-xs'); },
                    exit: function() { $body.removeClass('device-xs'); }
                }
            ]);
        },
    };
    PTEN.header = {
        init: function(){
            PTEN.header.superfish();
            PTEN.header.menuFunction();
            PTEN.header.stickyMenu();
        },
        superfish: function(){
            if( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) {
                $('#primary-menu-top ul ul').css('display', 'block');
                $('#primary-menu-top ul ul').css('display', '');

                if( !$().superfish ) {
                    $body.addClass('no-superfish');
                    console.log('superfish: Superfish not Defined.');
                    return true;
                }

                $('#primary-menu-top > ul').superfish({
                    popUpSelector: 'ul',
                    delay: 250,
                    speed: 350,
                    animation: {opacity:'show'},
                    animationOut:  {opacity:'hide'},
                    cssArrows: false,
                    onShow: function(){}
                });
            }
        },
        stickyMenu: function( headerOffset ){
            if ($window.scrollTop() > headerOffset) {
                if( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) {
                    $('#header:not(.no-sticky)').addClass('sticky-header');
                }
            }else {
                PTEN.header.removeStickyness();
            }
        },
        removeStickyness: function(){
            if( $header.hasClass('sticky-header') ){
                $('body:not(.side-header) #header:not(.no-sticky)').removeClass('sticky-header');
                $header.removeClass().addClass(oldHeaderClasses);
                $headerWrap.removeClass().addClass(oldHeaderWrapClasses);
            }
            if( $body.hasClass('device-sm') || $body.hasClass('device-xs') || $body.hasClass('device-md') ) {
                $header.removeClass().addClass(oldHeaderClasses);
                $headerWrap.removeClass().addClass(oldHeaderWrapClasses);
            }
        },
        menuFunction: function(){
            $( '#primary-menu ul li:has(ul)' ).addClass('sub-menu');
            if( $('#primary-menu').hasClass('on-click') || ( $body.hasClass('device-md') || $body.hasClass('device-sm') || $body.hasClass('device-xs') ) ) {
                $('#primary-menu li:has(ul) > a').on( 'click touchend', function(e){
                    var telem = $(this).parent('.sub-menu').siblings().find('ul');
                    if(telem.length) {
                        telem.slideUp('');
                    }
                    $(this).parent('li').children('ul').slideToggle();
                    $(this).toggleClass('opened');
                    e.preventDefault();
                });
            }
        },
    };
    PTEN.isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (PTEN.isMobile.Android() || PTEN.isMobile.BlackBerry() || PTEN.isMobile.iOS() || PTEN.isMobile.Opera() || PTEN.isMobile.Windows());
        }
    };
    PTEN.documentOnReady = {
        init: function(){
            PTEN.initialize.init();
            windowWidth = $window.width();
            PTEN.header.init();
            PTEN.documentOnReady.windowscroll();

            let hash = window.location.hash;
            if($("a[data-scrollto='" + hash + "']").length) {
                $("a[data-scrollto='" + hash + "']").click();
            }
            $('#primary-menu-trigger').off( 'click' ).on( 'click', function() {
                if($body.hasClass("primary-menu-open")) {
                    $body.addClass("primary-menu-hidden");
                    $html.removeClass('no-scroll');
                    $body.removeClass("primary-menu-open");
                }else{
                    $body.addClass("primary-menu-open");
                    $html.addClass('no-scroll');
                    $body.removeClass("primary-menu-hidden");
                }
                return false;
            });
            $( 'body.archive.post-type-archive-job-board .filter-form' ).on( 'change', 'select', function() {
                if($(this).val() == '') {
                    window.location.href = '/jobs';
                }else {
                    $(this).closest('form').find('#location').val($(this).val());
                    $(this).closest('form').submit();
                }
            });
        },
        topScrollOffset: function() {
            var topOffsetScroll = 0;

            if( ( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) && !PTEN.isMobile.any() ) {
                topOffsetScroll = 80;
                if($body.hasClass('admin-bar')) {
                    topOffsetScroll += 32;
                }
            } else if($body.hasClass('device-md')) {
                topOffsetScroll = 85;
            } else {
                topOffsetScroll = 46;
            }
            if($('.content-nav-wrapper').length) {
                topOffsetScroll += 30
            }
            return topOffsetScroll;
        },
        linkScroll: function(){
            $("a[data-scrollto]").off( 'click' ).on( 'click', function(){
                var element = $(this),
                    divScrollToAnchor = element.attr('data-scrollto'),
                    divScrollSpeed = element.attr('data-speed'),
                    divScrollOffset = element.attr('data-offset'),
                    divScrollEasing = element.attr('data-easing'),
                    divScrollHighlight = element.attr('data-highlight');
                if( element.parents('#primary-menu').hasClass('on-click') ) { return true; }

                if( !divScrollSpeed ) { divScrollSpeed = 750; }
                if( !divScrollOffset ) { divScrollOffset = PTEN.documentOnReady.topScrollOffset(); }
                if( !divScrollEasing ) { divScrollEasing = 'easeOutQuad'; }

                $('html,body').stop(true).animate({
                    'scrollTop': $( divScrollToAnchor ).offset().top - Number(divScrollOffset)
                }, Number(divScrollSpeed), divScrollEasing, function(){
                    if( divScrollHighlight ) {
                        if( $(divScrollToAnchor).find('.highlight-me').length > 0 ) {
                            $(divScrollToAnchor).find('.highlight-me').animate({'backgroundColor': divScrollHighlight}, 300);
                            var t = setTimeout( function(){ $(divScrollToAnchor).find('.highlight-me').animate({'backgroundColor': 'transparent'}, 300); }, 500 );
                        } else {
                            $(divScrollToAnchor).animate({'backgroundColor': divScrollHighlight}, 300);
                            var t = setTimeout( function(){ $(divScrollToAnchor).animate({'backgroundColor': 'transparent'}, 300); }, 500 );
                        }
                    }
                });

                return false;
            });
        },
        windowscroll: function(){
            var headerWrapOffset = 0;
            if( $header.length > 0 ) { headerWrapOffset = $headerWrap.offset().top; }
            PTEN.header.stickyMenu( headerWrapOffset );
            $window.on( 'scroll', function() {
                PTEN.header.stickyMenu(headerWrapOffset);
            });
        },
    };
    PTEN.documentOnLoad = {
        init: function(){
        }
    };
    PTEN.documentOnResize = {
        init: function(){
            windowWidth = $window.width();
            if( PTEN.isMobile.any() ){
                $body.addClass('device-touch');
            }
        }
    };
    var $window = $(window),
        $header = $('#header'),
        $headerWrap = $('#header-wrap'),
        oldHeaderClasses = $header.attr('class'),
        oldHeaderWrapClasses = $headerWrap.attr('class'),
        $body = $('body'),
        $html = $('html'),
        windowWidth;

    $(document).ready( PTEN.documentOnReady.init );
    $window.on( 'load', PTEN.documentOnLoad.init );
    $window.on( 'resize', PTEN.documentOnResize.init );



	$('.is-style-btp-sparkle').each(function() {
		var $this = $(this);
		$this.addClass('btp-sparkle');
		var content = $this.html();
		var newContent = btp.sparkle_html.replace('{{content}}', content);
		$this.html(newContent);
	});



    // collapse the nnavbar
    document.body.addEventListener('click', function(event) {
        var navbarNavDropdown = document.getElementById('navbarNavDropdown');
        if (!navbarNavDropdown.contains(event.target)) {
          navbarNavDropdown.classList.remove('show');
        }
    });



    //home video modal
		$('#homeVideoModal').on('show.bs.modal', function (event) {
			var iframe = $(this).find('iframe')[0];
			// Check if the iframe exists
			if (iframe) {
				// Get the source of the iframe
				var src = $(iframe).attr('src');
				// Add the "autoplay" parameter to the source URL
				src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
				// Set the modified source back to the iframe
				$(iframe).attr('src', src);
			}
		})

		$('#homeVideoModal').on('hide.bs.modal', function (event) {
			var iframe = $(this).find('iframe')[0];
			// Check if the iframe exists
			if (iframe) {
				// Get the source of the iframe
				var src = $(iframe).attr('src');
				src = src.replace(/[\?&]autoplay=1/, '');
				// Set the source to an empty string to stop the video
				$(iframe).attr('src', '');
				// Set the source back to the original URL after a short delay (optional)
				setTimeout(function () {
					$(iframe).attr('src', src);
				}, 500);
			}
			console.log('close');
		})




 


})(jQuery);

